import { render, staticRenderFns } from "./partnersLogos.vue?vue&type=template&id=57102f54&"
import script from "./partnersLogos.vue?vue&type=script&lang=js&"
export * from "./partnersLogos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports